import React from 'react';

// A single wallet card component
export const WalletCard = ({ wallet }) => {
  // Format the balance as a currency string (you can adjust locales & options as needed)
  const formattedBalance = Number(wallet.balance).toLocaleString(undefined, {
    style: 'currency',
    currency: wallet.currencyCode,
    maximumFractionDigits: 2,
  });

  return (
    <div className="bg-white/10 dark:bg-black/20 mb-5 rounded-xl shadow-md hover:shadow-lg transition transform hover:scale-105 duration-300 p-6">
      {/* Header: Flag and currency info */}
      <div className="flex flex-row items-center justify-between mb-2">
        <div className="flex items-center">
          <div className="w-8 h-8 mr-2">
            <img
              src={`https://flagcdn.com/48x36/${wallet.flagCode.toLowerCase()}.png`}
              alt={`${wallet.country} flag`}
              className="w-full h-full object-cover rounded-full"
            />
          </div>
          <div>
            <h2 className="text-md font-bold text-white">
              {wallet.currencyName}
            </h2>
            {/* <p className="text-xs text-start text-gray-500">{wallet.currencyCode}</p> */}
          </div>
        </div>
        <div className="">
          {wallet.defaultWallet === 'true' && (
            <div className="absolute right-1 -top-2 inline-block px-4 py-2 text-xs bg-green-200 text-green-800 rounded-lg">
              Default Wallet
            </div>
          )}
        </div>
      </div>

      {/* Balance Section */}
      <div>
        <div className="text-xs uppercase text-start text-gray-100/70 mb-1">Balance</div>
        <div className="text-2xl text-start font-semibold text-white">
          {formattedBalance}
        </div>
      </div>
    </div>
  );
};
